import createGetFormMeta from './selectors/getFormMeta';
import plain from './structure/plain';

export default createGetFormMeta(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/getFormMeta.js
// module id = 4261
// module chunks = 25